import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthProvider";
import { ErrorProvider } from "./context/ErrorProvider";
import ErrorModal from "./components/error/Error";
import { QueryClient, QueryClientProvider } from "react-query";
import { BorrowerProvider } from "./context/BorrowerContext";
import { LoanApplicationProvider } from "./context/LoanApplicationContext";
import { GuarantorProvider } from "./context/GuarantorContext";
import "react-calendar/dist/Calendar.css";
import AutoLogoutWarning from "./components/autologout/AutoLogout";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const root = createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <AuthProvider>
        <BorrowerProvider>
          <LoanApplicationProvider>
            <GuarantorProvider>
              <ErrorProvider>
                <App />
                <AutoLogoutWarning />
                <ErrorModal />
              </ErrorProvider>
            </GuarantorProvider>
          </LoanApplicationProvider>
        </BorrowerProvider>
      </AuthProvider>
    </BrowserRouter>
  </QueryClientProvider>,
);
